export default __webpack_public_path__ + "static/media/Kannada_weather_f.51683530.wav";